import { HTMLAttributes } from 'react';

import {
  Typography,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {},
});

export interface ActivityItemSectionProps
  extends HTMLAttributes<HTMLDivElement>,
    WithStyles<typeof styles> {
  label: string;
}

const ActivityItemSection = (props: ActivityItemSectionProps) => {
  const { label, children, className, classes, ...rest } = props;

  return (
    <div className={classNames(classes.root, className)} {...rest}>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      {children}
    </div>
  );
};

export default withStyles(styles)(ActivityItemSection);
